// ----------------------------------------------------------------------------
// Nombre del Programa : VistaComunicado
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones la vista previa de el comunicado
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// Se agregaron funcionalidad de fechas importantes y de configurar un recordario  Fecha: 25/JUN/2024
// Se agregaron funcionalidad para que los administradores puedan editar el comunicado desde la vista  Fecha: 27/JUN/2024
// Se agregaron funcionalidad para guardar favoritos y recordatios  Fecha: 30/JUN/2024
// Se agrego funcionalidad para mostrar # y redirigir al buscador  Fecha: 09/JUL/2024
// Se modificaron etiquetas 20/AGO/2024
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import "./VistaComunicado.scss";
import { Row, Col, Badge, Alert } from "react-bootstrap";
import { BotonRegresar } from "../../../components/boton-regresar/BotonRegresar";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ComunicadosProps,
  FavoritosImportantesProps,
  FavoritosProps,
  FavoritosImportantesDeleteProps,
} from "../../../interfaces/comunicadosInterfaces";
import { AdjuntosProps } from "../../../interfaces/adjuntosInterfaces";
import moment from "moment";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { StatusAlertService } from "react-status-alert";
import {
  getComunicadoHome,
  postFavoritoImportante,
  getComunicadoFavoritos,
  deleteFavorito,
  getComunicados,
} from "../../../Services/ComunicadosService";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getadm,getApiCliGoo } from "../../../Utilidades/session";
import favnegro from "../../../assets/images/favnegro.png";
import favrojo from "../../../assets/images/favrojo.png";
import userImage from "../../../assets/images/userImage.png";

import {
  consultarLikeOrDislike,
  likeOrDislike,
} from "../../../Services/LikeDislikeService";
import { ComunicadoVotoRequest } from "../../../interfaces/likeDislikesInterfaces";
import {
  activarDesactivarComentario,
  consultarComentarios,
  crearComentario,
} from "../../../Services/ComentariosService";
import {
  ComentarioRequest,
  ComentarioResponse,
} from "../../../interfaces/comentariosInterfaces";
import { getRoli } from '../../../Utilidades/session';

export const VistaComunicado = () => {
  const params = useParams();
  const navigate = useNavigate();
  const userId = useSelector((state: any) => state.authUser.userId);
  const rolId = useSelector((state: any) => getRoli());
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const usergoogleid = useSelector((state: any) => state.authUser.googleId);

  const user = useSelector((state: any) => state.authUser);
  const [comunicado, setComunicado] = useState<ComunicadosProps>();
  const [comunicadoId, setComunicadoId] = useState<number>(0);
  const [favoritosImportantes, setFavoritosImportantes] =
    useState<FavoritosImportantesProps>();
  const [favoritos, setFavoritos] = useState<FavoritosProps[]>([]);
  const [esFavorito, setEsFavorito] = useState<boolean>(false);
  const [comunicadoFavoritoId, setComunicadoFavoritoId] = useState<number>(0);
  const [likes, setLikes] = useState<number>(0);
  const [dislikes, setDislikes] = useState<number>(0);
  const [comentarioTexto, setComentarioTexto] = useState<string>("");
  const [innerComentarioTexto, setInnerComentarioTexto] = useState<string>("");
  const [editando, setEdintando] = useState<number>(0);
  const [comentarios, setComentarios] = useState<ComentarioResponse[]>([]);
  //Modificacion: Marca de Fin WII C-24-1229-24

  var visto = false;

  //Modificacion: Marca de Inicio WII C-24-1229-24
  useEffect(() => {
    obtenerComunicado();

  
  }, []);

  const obtenerComunicado = async () => {
    const comunicadoId = params.comunicadoId;
   
    const response: any = await getComunicadoHome(comunicadoId!).catch(
      () => procesarError
    );
    if (response.data?.data?.length) {
      const datos: ComunicadosProps = response.data?.data[0];
      setComunicado(datos);
      if (!visto) {
        visto = true;
        ReactGA.event("comunicado_visto", {
          comunicado_titulo: datos.titulo,
          comunicado_id: datos.comunicado_id,
          user_id: userId,
        });
      }

      setComunicadoId(datos.comunicado_id)
      consultarLikesDislikes(datos.comunicado_id);
      consultarComentariosComunicado(datos.comunicado_id);
      cargarFavoritosImportantes(datos.comunicado_id);
      return;
    }
    procesarError();
  };

  const cargarFavoritosImportantes = async (comunicadoid: number) => {
    const response: any = await getComunicadoFavoritos(usergoogleid).catch(
      () => {}
    );
    if (response.data?.data) {
      const elementosnoeli = response.data.data.favoritos.filter(
        (favoritos) => favoritos.comunicado_id === comunicadoid
      );
      if (elementosnoeli != null && elementosnoeli.length > 0) {
        setComunicadoFavoritoId(elementosnoeli[0].comunicadofavorito_id);
        setEsFavorito(true);
      }
    }
  };

  const procesarError = () => {
    navigate("/", { replace: true });
  };

  const abrirAdjunto = (adjunto: AdjuntosProps) => {
    window.open(adjunto.urlAdjunto, "_blank");
    ReactGA.event("comunicado_adjunto", {
      comunicado_titulo: comunicado!.titulo,
      comunicado_id: comunicado!.comunicado_id,
      adjunto: adjunto.nombre,
      user_id: userId,
    });
  };

  const fechaFormato = (fecha) => {
    return moment(fecha).format("DD/MM/YYYY");
  };

  const onClickContenido = (ev) => {
    if (ev.target.tagName.toLowerCase() === "a") {
      let url = ev.target.href || ev.target.textContent;
      url = url.slice(0, 99);
      ReactGA.event("comunicado_link", {
        comunicado_titulo: comunicado!.titulo,
        comunicado_id: comunicado!.comunicado_id,
        url,
        user_id: userId,
      });
    }
  };
  const abrirCalendar = () => {
    window.open(comunicado?.url_calendario, "_blank");
  };
  const guardarFavoritoRecordatorio = async () => {
    let favoritosImportantes = {} as FavoritosImportantesProps;

    favoritosImportantes.tipofavorito = "REC";
    favoritosImportantes.comunicado_id = comunicado?.comunicado_id!;
    favoritosImportantes.idu_google = usergoogleid;

    //console.log('comuicado', comuicado)

    const response: any = await postFavoritoImportante(
      favoritosImportantes
    ).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      //navigate(-1);
      StatusAlertService.showSuccess("Guardado Exitosamente");
    } else {
      StatusAlertService.showError(
        "Has llegado al limite de tus accesos directos"
      );
    }
  };
  const guardarFavorito = async () => {
    if (!esFavorito) {
      let favoritosImportantes = {} as FavoritosImportantesProps;

      favoritosImportantes.tipofavorito = "FAV";
      favoritosImportantes.comunicado_id = comunicado?.comunicado_id!;
      favoritosImportantes.idu_google = usergoogleid;

      //console.log('comuicado', comuicado)

      const response: any = await postFavoritoImportante(
        favoritosImportantes
      ).catch(({ response }) => {
        const { data } = response;
        StatusAlertService.showError(data.meta.message);
      });
      if (response.data && response.data.data) {
        //navigate(-1);
        setEsFavorito(true);
        setComunicadoFavoritoId(response.data.data.comunicadofavorito_id);
        StatusAlertService.showSuccess("Guardado Exitosamente");
      } else {
        StatusAlertService.showError(
          "Has llegado al limite de tus accesos directos"
        );
      }
    } else {
      let favoritosImportantes = {} as FavoritosImportantesDeleteProps;
      favoritosImportantes.comunicadofavorito_id = comunicadoFavoritoId;
      const response: any = await deleteFavorito(favoritosImportantes).catch(
        ({ response }) => {
          const { data } = response;
          StatusAlertService.showError(data.meta.message);
        }
      );
      if (response.data && response.data.data) {
        setEsFavorito(false);
        StatusAlertService.showSuccess("Borrado Exitosamente");
      }
    }
  };
  const abrirBuscador = async () => {
    navigate("/buscador/", {
      replace: false,
      state: { palabraClave: comunicado!.palabras_clave },
    });
  };

  const votar = (like: boolean) => {
    let votoRequest = {} as ComunicadoVotoRequest;
    //const idGoogle = getApiCliGoo();
    votoRequest.idComunicado = comunicado?.comunicado_id!;
    votoRequest.idUsuario = user.usuarioId;
    votoRequest.idGoogle = usergoogleid;
    votoRequest.voto = like;

    likeOrDislike(votoRequest)
      .then((result) => {
        if (result.data && result.data.data) {
          if(result.data.data.error != null){
            StatusAlertService.showSuccess(result.data.data.error);
          }else{
            setLikes(result.data.data.likes);
            setDislikes(result.data.data.dislikes);
          }
        }
      })
      .catch((erro) => procesarError());
  };

  const consultarLikesDislikes = (idComunicado: number) => {
    consultarLikeOrDislike(idComunicado)
      .then((result) => {
        if (result.data && result.data.data) {
          setLikes(result.data.data.likes);
          setDislikes(result.data.data.dislikes);
        }
      })
      .catch((erro) => procesarError());
  };

  const deshabiliarComentario = (id: number)=> {
    activarDesactivarComentario(id)
      .then((result) => {
        consultarComentariosComunicado(comunicadoId);
      })
      .catch(() => {
        StatusAlertService.showError("Error al activar/desactivar comentario");
    });
  }
  const nuevoComentario = (isSub?:boolean) => {
    let request = {} as ComentarioRequest;
    //const idGoogle = getApiCliGoo();
    request.idComunicado = comunicado?.comunicado_id!;
    request.idUsuario = user.usuarioId;
    request.idGoogle = usergoogleid;
    request.googleNombre = user.name;
    
    if(isSub){
      request.idComentarioPadre = editando;
      request.comentario = innerComentarioTexto;
      if(innerComentarioTexto.length == 0 || innerComentarioTexto == null){
        StatusAlertService.showError("Se requiere agregar comentario");
        return false;
      }
    }else{
      request.comentario = comentarioTexto;
      if(comentarioTexto.length == 0 || comentarioTexto == null){
        StatusAlertService.showError("Se requiere agregar comentario");
        return false;
      }
    }
    

    crearComentario(request)
      .then((result) => {
        consultarComentariosComunicado(comunicadoId);

        console.log(result);
      })
      .catch((error) => console.log(error));
  };

  const clean = ()=>{
    setComentarioTexto("");
    setInnerComentarioTexto("");
    setEdintando(0)
  }

  const consultarComentariosComunicado = (idComunicado: number) => {
    consultarComentarios(idComunicado)
      .then((result) => {

        console.log(user);
        
        console.log("results comentarios", result);

        if (result.data && result.data.data) {
          clean()
          setComentarios(result.data.data);
        }
      })
      .catch((erro) => procesarError());
  };

  const boxComments = (item : any) =>{
      if(rolId == '3'){
        return (<div className="reply-section mt-3">
          <div className="comment-box">
            <div className="d-flex gap-3">
              <img
                  src={userImage}
                alt="User Avatar"
                className="user-avatar"
              />
              <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">{item.usuario.nombre}</h6>
                    <Form.Check 
                      type="switch"
                      id="controlled-switch"
                      label={`${item.estatus == 1 ? 'Activo' : 'Inactivo'}`}
                      checked={(item.estatus == 1? true:false)}
                      onChange={()=>{ deshabiliarComentario(item.id) }}
                    />
                  <span className="comment-time">
                    {item.fecha}
                  </span>
                </div>
                <p className="mb-2">{item.comentario}</p>
              </div>
            </div>
          </div>
        </div>)
      }else if(rolId != '3' && item.estatus == 1){
        return (<div className="reply-section mt-3">
          <div className="comment-box">
            <div className="d-flex gap-3">
              <img
                  src={userImage}
                alt="User Avatar"
                className="user-avatar"
              />
              <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">{item.usuario.nombre}</h6>
                  <span className="comment-time">
                    {item.fecha}
                  </span>
                </div>
                <p className="mb-2">{item.comentario}</p>
              </div>
            </div>
          </div>
        </div>)
      }
      
  }

  const boxCommentFather = (item: any) => {
    if (rolId == '3') {
      return (<>
      <div className="d-flex gap-3">
        <img
          src={userImage}
          alt="User Avatar"
          className="user-avatar"
        />
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0">{item.usuario.nombre}</h6>
            <Form.Check
              type="switch"
              id="controlled-switch-padre"
              label={`${item.estatus == 1 ? 'Activo' : 'Inactivo'}`}
              checked={(item.estatus == 1 ? true : false)}
              onChange={() => { deshabiliarComentario(item.id) }}
            />
            <span className="comment-time">
              {item.fecha}
            </span>
          </div>
          <p className="mb-2">{item.comentario}</p>
          <div className="comment-actions">
            {(item.id == editando) && (
              <>
                <Form.Control
                  as="textarea"
                  value={innerComentarioTexto}
                  onChange={(e) => {
                    setInnerComentarioTexto(e.target.value);
                  }}
                  placeholder="Comentar"
                  style={{ height: "100px" }}
                />
                <Row>
                  <Col md="2"><Button variant="primary" size="sm" onClick={() => nuevoComentario(true)}>Responder</Button></Col>

                  <Col md="1"> <Button variant="danger" size="sm" onClick={() => setEdintando(0)}>Cancelar</Button></Col>
                </Row>


              </>

            )}

            {
              (item.id != editando) && (
                <span onClick={() => { setEdintando(item.id) }}>Responder</span>
              )
            }

          </div>
        </div>
        </div>
      </>)
    } else if (rolId != '3' && item.estatus == 1) {
      return (<>
      <div className="d-flex gap-3">
        <img
          src={userImage}
          alt="User Avatar"
          className="user-avatar"
        />
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0">{item.usuario.nombre}</h6>
            <span className="comment-time">
              {item.fecha}
            </span>
          </div>
          <p className="mb-2">{item.comentario}</p>
          <div className="comment-actions">
            {(item.id == editando) && (
              <>
                <Form.Control
                  as="textarea"
                  value={innerComentarioTexto}
                  onChange={(e) => {
                    setInnerComentarioTexto(e.target.value);
                  }}
                  placeholder="Comentar"
                  style={{ height: "100px" }}
                />
                <Row>
                  <Col md="2"><Button variant="primary" size="sm" onClick={() => nuevoComentario(true)}>Responder</Button></Col>

                  <Col md="1"> <Button variant="danger" size="sm" onClick={() => setEdintando(0)}>Cancelar</Button></Col>
                </Row>


              </>

            )}

            {
              (item.id != editando) && (
                <span onClick={() => { setEdintando(item.id) }}>Responder</span>
              )
            }
          </div>
        </div>
        </div>
      </>)
    }
  }

  //Modificacion: Marca de Fin WII C-24-1229-24
  return comunicado ? (
    <>
      <Row className="comunicado-header pt-3">
        <BotonRegresar></BotonRegresar>
        {getadm() == "1" ? (
          <Link to={"/comunicados/comunicado/" + comunicado.comunicado_id}>
            <Button variant="primary" className="botoneditartop">
              Editar
            </Button>
          </Link>
        ) : null}
      </Row>
      <Row className="comunicado-header pt-3">
        <div className="imagen-portada">
          {comunicado.urlImagenPortada ? (
            <Col md={12}>
              <img
                className="comunicado-imagen"
                src={
                  comunicado.urlImagenPortada
                    ? comunicado.urlImagenPortada
                    : comunicado.urlImagenBanner
                }
              />
            </Col>
          ) : null}
          <Col md={12} className="contenedor-titulo pt-3">
            <div className="titulocomunicado h5 mb-3 mt-3 ml-3 mr-3 pt-2 pb-2">
              <p> {comunicado?.titulo}</p>

              <div className=" butts ">
                <Button variant="outline" onClick={() => votar(true)}>
                  <div className="material-icons">thumb_up</div>
                  <Badge>{likes}</Badge>
                </Button>
                {/* <Button variant="outline" onClick={() => votar(false)}>
                  <div className="material-icons">thumb_down</div>
                  <Badge>{dislikes}</Badge>
                </Button> */}
              </div>
            </div>
          </Col>
        </div>
        {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
        <div className="imagen-portadamobil">
          {comunicado.urlImagenHome ? (
            <Col md={12}>
              <img
                className="comunicado-imagen"
                src={
                  comunicado.urlImagenHome
                    ? comunicado.urlImagenHome
                    : comunicado.urlImagenBanner
                }
              />
            </Col>
          ) : null}
          <Col md={12} className="contenedor-titulo pt-3">
            <div className="titulocomunicado h5 mb-3 mt-3 ml-3 mr-3 pt-2 pb-2">
              {comunicado?.titulo}
            </div>
          </Col>
        </div>
      </Row>
      <Row className="comunicado-header pt-3 padingtop0">
        <div className="d-flex flex-row-reverse flex-row-movil bd-highlight mt-3 me-3 ml-3 wp98 zposicion">
          <img
            className="fav-negro favoritomovil me-2 cursospointer"
            onClick={() => guardarFavorito()}
            src={esFavorito ? favrojo : favnegro}
          />
          <Form.Label
            className="w220 cursospointer textaf"
            onClick={() => guardarFavorito()}
          >
            {esFavorito
              ? "Elimina de tus notas favoritas"
              : "Agrega a tus notas favoritas"}
          </Form.Label>
          <img
            className="fav-negro favoritonomovil me-2 cursospointer"
            onClick={() => guardarFavorito()}
            src={esFavorito ? favrojo : favnegro}
          />
        </div>
      </Row>
      {/*Modificacion: Marca de Fin WII C-24-1229-24*/}
      <Row className="comunicado-header margentitulofav pt-0">
        <Col md={1}></Col>
        <Col
          md={comunicado.urlImagenPortada ? 10 : 10}
          className="comunicado-info pt-3"
        >
          <div className="comunicado-descripcion contenido-espacio mb-3">
            {comunicado?.descripcion}
          </div>
          <div className="comunicado-fecha">
            Publicado el {fechaFormato(comunicado?.fechaPublicacion)}
          </div>
        </Col>
      </Row>
      <Row className="comunicado-header pt-3">
        <Col md={1}></Col>
        <Col md={10} className="pt-3 pb-3">
          <div
            onClick={onClickContenido}
            className="mb-2"
            dangerouslySetInnerHTML={{
              __html: comunicado!.contenido,
            }}
          ></div>
          {comunicado.adjuntosFiles.map((adj) => {
            return (
              <div
                className="comunicado-adjunto link"
                onClick={() => abrirAdjunto(adj)}
              >
                <div className="material-icons-outlined">attachment</div>{" "}
                {adj.nombre}
              </div>
            );
          })}
        </Col>
      </Row>
      {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
      {comunicado.palabras_clave ? (
        <Row className="comunicado-header pt-4 pb-1">
          <Col md={1}></Col>
          <Col md={6} className="minimocolumna">
            <Form.Label
              onClick={() => abrirBuscador()}
              className="me-5 labelunderlinerojo"
            >
              {comunicado.palabras_clave}
            </Form.Label>
          </Col>
        </Row>
      ) : null}
      {comunicado.url_calendario ? (
        <Row className="comunicado-header pt-2 pb-4">
          <Col md={1}></Col>
          <Col md={6} className="minimocolumna">
            <Form.Label
              onClick={() => guardarFavoritoRecordatorio()}
              className="me-5 labelunderlinerojo"
            >
              Agregar a fechas importantes
            </Form.Label>
            <Form.Label
              onClick={() => abrirCalendar()}
              className="labelunderlinerojo"
            >
              Configurar un recordatorio en tu calendario
            </Form.Label>
          </Col>
        </Row>
      ) : null}
      {/*Modificacion: Marca de Fin WII C-24-1229-24*/}
      <Row>
        <div className="comment-section">
          <div className="mb-4">
            <div className="d-flex gap-3">
              <img
                src={user.imageUrl}
                alt="User Avatar"
                className="user-avatar"
              />
              <div className="flex-grow-1">
                <textarea
                  value={comentarioTexto}
                  onChange={(e) => {
                    setComentarioTexto(e.target.value);
                  }}
                  className="form-control comment-input"
                  rows={3}
                  placeholder="Escribe tu comentario..."
                ></textarea>
                <div className="mt-3 text-end">
                  <button
                    className="btn btn-comment text-white"
                    onClick={() => nuevoComentario()}
                  >
                    Comentar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="comments-list">
            {comentarios &&
              comentarios.map((single, index) => (
                (rolId == '3' || (rolId != '3' && single.estatus == 1)) && (
                  <div className="comment-box" key={index}>
                    {boxCommentFather(single)}
                    
                    {single.hijos.map((inner) => (
                      boxComments(inner)
                    ))}
                </div>
                )    
                
              ))}
          </div>
        </div>
      </Row>
    </>
  ) : null;
};
